import { useOutletContext } from "react-router-dom";
import EventEmitter from "../../utils/eventEmitter";
import Axios from "../utils/axios"


export const loadStockCounts = async () => {
  try {
    const response = await Axios.get('stock-counts');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};

const loadOneStockCount = async (seo) => {
  try {
    const respnse = await Axios.get('stock-counts/find/'+seo);
    const responseData = await respnse.data;
    return responseData;
  }catch (err) {
    throw err;
  }
}

export const loadStockCount = async (action) => {
  try {
    switch (action) {
      case 'new':
        const response = await Axios.get('setups/stock-counts');
        const responseData = await response.data;
        return {...responseData, stockCount: {status: 'draft'}};
        
      default:
        const data = await loadOneStockCount(action);
        return data;
    }
  }catch (err) {
    throw err;
  }
}


export const loadStockCountInventory = async (location, id) => {
  try {
    const filter = encodeURI(JSON.stringify({location_id: location, count_id: id}));
    const response = await Axios.get('stock-counts/inventory/'+filter);
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};


export const loadStockCountProductMoves = async (count_id) => {
  try {
    // const filter = encodeURI(JSON.stringify({status: 'done', location: location}));
    const respnse = await Axios.get('stock-counts/product-moves/'+count_id);
    const responseData = await respnse.data;
    return responseData;
  }catch (err) {
    throw err;
  }
}




const useStockCountAPI = () => {
  const { success, error } = useOutletContext();

  const create = async (data) => {
    try {
      const respnse = await Axios.post('stock-counts', data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('stockcount_response');
    }catch(err) {
      throw err;
    }
  }

  const update = async (name, data) => {
    try {
      const respnse = await Axios.put('stock-counts/'+name, data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('stockcount_response', data.id);
    }catch (err) {
      throw err;
    }
  }

  const startCount = async (seo, data) => {
    try {
      const respnse = await Axios.put('stock-counts/start/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('stockcount_response', seo);
      return responseData.data;
    }catch (err) {
      throw err;
    }
  }

  const submitStockCount = async (seo) => {
    try {
      const respnse = await Axios.patch('stock-counts/submit/'+seo);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('stockcount_response', seo);
    }catch (err) {
      throw err;
    }
  }

  const validateStockCount = async (seo) => {
    try {
      const respnse = await Axios.patch('stock-counts/validate/'+seo);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('stockcount_response', seo);
    }catch (err) {
      throw err;
    }
  }


  const cancelCount = async (seo) => {
    try {
      const respnse = await Axios.patch('stock-counts/cancel/'+seo);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('stockcount_response', seo);
    }catch (err) {
      throw err;
    }
  }

  const adjustCount = async (data) => {
    try {
      const respnse = await Axios.put('stock-counts/inventory/counting', data);
      const responseData = await respnse.data;
      success(responseData.message);
    }catch (err) {
      throw err;
    }
  }


  const generateStockSheets = async (count_id) => {
    try {
      const respnse = await Axios.get('stock-counts/generate-count-sheet/'+count_id);
      const responseData = await respnse.data;
      return responseData;
    }catch (err) {
      throw err;
    }
  }
  return { create, update, startCount, submitStockCount, adjustCount, validateStockCount, generateStockSheets, cancelCount };
};


export default useStockCountAPI;